import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".rm-folders-manage-posts article[elid]";

export default function loadFollowButton(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
